import React from 'react';

export default class DpcAllegato extends React.Component {

    getIconAllegato = (extension) => {

        if (extension) {
            switch (extension) {
                case 'pdf': {
                    return <span className="icon-file icon-file-pdf" title="File formato PDF"/>
                }
                case 'csv': {
                    return <span className="icon-file icon-file-csv" title="File formato CSV"/>
                }
                case 'docx':
                case 'doc': {
                    return <span className="icon-file icon-file-doc" title="File formato DOC"/>
                }
                case 'jpeg': {
                    return <span className="icon-file icon-file-jpeg" title="File formato JPEG"/>
                }
                case 'ppt': {
                    return <span className="icon-file icon-file-ppt" title="File formato PPT"/>
                }
                case 'xls':
                case 'xlsx': {
                    return <span className="icon-file icon-file-xls" title="File formato XLS"/>
                }
                case 'xml': {
                    return <span className="icon-file icon-file-xml" title="File formato XML"/>
                }
                case 'm4a':
                case 'mp3':
                case 'wav':{
                    return <span className="icon-file icon-file-audio" title="File Audio"/>
                }

                default: return <span className="icon-file" title="File formato Generico"/>
            }
        } else {
            return <span className="icon-file" title="File formato Generico"/>
        }

    };

    render() {
        return (
            <li>
                <a href={this.props.slug} target="_blank" title={`Scarica il ${this.props.titolo}`} rel="noreferrer">
                    <div className="it-rounded-icon">
                        {this.getIconAllegato(this.props.extension)}
                    </div>
                    <div className="it-right-zone">
                        <span className="text" style={{overflowWrap:"anywhere"}}>
                        {`${this.props.titolo} ${this.props.descrizione? `: ${this.props.descrizione}`:``}`} ({Math.round((this.props.dimension / 1024)) + " Kb"})
                        </span>
                    </div>
                </a>
            </li>
        )
    }
}
